export default "__VITE_ASSET__5aac59b2__"